import { render, staticRenderFns } from "./PackageClassification.vue?vue&type=template&id=3041ee04&scoped=true&"
import script from "./PackageClassification.vue?vue&type=script&lang=js&"
export * from "./PackageClassification.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PackageClassification.vue?vue&type=style&index=1&id=3041ee04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041ee04",
  null
  
)

export default component.exports